import React from 'react';
import { cn } from '@utils/cn';

export interface ToggleSwitchProps {
  leftLabel: string;
  rightLabel: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  testId?: string;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  leftLabel,
  rightLabel,
  checked,
  onChange,
  disabled = false,
  className,
  testId,
}) => {
  const handleChange = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div className={cn("flex items-center space-x-3", className)}>
      <label
        className={cn(
          "inline-flex items-center select-none",
          disabled ? "cursor-not-allowed" : "cursor-pointer"
        )}
      >
        <span
          className={cn(
            "text-sm font-medium mr-3",
            !checked ? "text-blue-600" : "text-gray-500",
            disabled && "opacity-50"
          )}
        >
          {leftLabel}
        </span>
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className="sr-only peer"
          data-testid={testId}
        />
        {/* The track is the positioned box for the `after:` thumb; label spans stay outside it. */}
        <div
          className={cn(
            "relative shrink-0 w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600",
            disabled && "opacity-50"
          )}
        ></div>
        <span
          className={cn(
            "text-sm font-medium ml-3",
            checked ? "text-blue-600" : "text-gray-500",
            disabled && "opacity-50"
          )}
        >
          {rightLabel}
        </span>
      </label>
    </div>
  );
};